module.exports = __webpack_public_path__ + "static/media/user.89c763ff.svg";